import { isEta } from '../config';
import { getIdentifiedUrl } from '../etaUtils';
import { uuid } from '../metaData';
import { getReqSeqByLogQueue } from '../reporter';
import { transToFormData } from './dataUtil';

const docsLogDomain = isEta ? 'docs-fe.qingque.cn' : 'docs-h2.corp.kuaishou.com';

function sendBeacon(url: string, data: FormData) {
  try {
    const sendSuccess = navigator.sendBeacon(url, data);
    if (!sendSuccess) {
      fetch(url, {
        method: 'POST',
        credentials: 'include',
        body: data
      });
    }
    return sendSuccess;
  } catch (e) {
    console.error(e);
    return false;
  }
}

/**
 * 批量日志到docs后端：转发至日志平台 & 数仓，仅用于docs项目
 * https://docs.corp.kuaishou.com/d/home/fcAACzN96CPh-n6oH31bZD5ud
 */
export function sendBeaconToDocsLog(data: Record<string, any>) {
  const seq = getReqSeqByLogQueue(data);
  const url = getIdentifiedUrl(
    `https://${docsLogDomain}/log/api/fe-log/multi?uuid=${uuid}&seq=${seq}`
  );
  return sendBeacon(url, transToFormData({ multiLogBody: JSON.stringify(data) }));
}

let statisticSeq = 0;

/**
 * 单条统计到docs后端：支持formData
 */
export function sendBeaconToDocsStatistic(data: Record<string, any>) {
  const url = getIdentifiedUrl(
    `https://${docsLogDomain}/log/api/report?uuid=${uuid}&seq=${++statisticSeq}`
  );
  return sendBeacon(url, transToFormData(data));
}
